import Stickyfill from "stickyfilljs";
import readingTime from "reading-time";
import { includes } from "lodash";

import "../scss/index.scss";

import "jquery-ui/ui/widgets/selectmenu";

import Search from "./search";
import ArticleFeedback from "./article-feedback";
import Sidebar from "./sidebar";
import ImageZoom from "./image-zoom";
import Header from "./header";

import { initCodeBlockFeatures } from "./syntax";
import Breadcrumbs from "./breadcrumbs";
import LicenseKey from "./license-key";
import ProgressSidebar from "./progress-sidebar";
import Cards from "./cards";
import Accordion from "./accordion";
import CfButton from "./cf-button";
import PackageButton from "./package-button";
import TrackClick from "./track-click";
import Tables from "./tables";

const NEW_DOCS_URL = "https://docs.singlestore.com";
const ARCHIVED_VERSION_END = 7.1;

// Promise polyfill
require("es6-promise").polyfill();

$(document).ready(() => {
    const search = new Search();
    const articleFeedback = new ArticleFeedback();
    const sidebar = new Sidebar();
    const imageZoom = new ImageZoom();
    const header = new Header();
    const breadcrumbs = new Breadcrumbs();
    const licenseKey = new LicenseKey();
    const progressSidebar = new ProgressSidebar();
    const cards = new Cards();
    const accordion = new Accordion();
    const cfButton = new CfButton();
    const packageButton = new PackageButton();
    const trackClick = new TrackClick();
    const tables = new Tables();

    const sidebarSelector = ".sidebar";
    const mainSelector = ".main";
    const navbarComponentRoot = "#navbar-component-root";
    const cookieBannerWrapper = "#singlestore-cookie-banner-wrapper";
    const autoCompleteSelector = ".autocomplete-container";

    search.mount({
        inputSelector: ".search-box .search-input",
        smallScreenWidth: 800,
        navbarComponentRoot,
        autoCompleteSelector
    });

    articleFeedback.mount({
        feedbackPopupId: "#feedback-popup",
        feedbackModalId: "#feedback-modal",
        feedbackArticleEndId: "#feedback-article-end",
    });

    sidebar.mount({
        sidebarSelector,
        mainSelector,
        navbarComponentRoot,
        cookieBannerWrapper
    });

    imageZoom.mount({
        imageSelector: ".main img",
        imageModalSelector: "#image-zoom-modal",
    });

    header.mount({
        searchBarSelector: ".search-box",
        navbarSelector: ".navbar-component",
        autoCompleteSelector,
        sidebarSelector,
        navbarComponentRoot,
        cookieBannerWrapper
    });

    breadcrumbs.mount({
        breadcrumbsSelector: ".breadcrumbs .fa-home",
        sidebarSelector,
        mainSelector,
    });

    licenseKey.mount({
        licenseKeySelector: ".license-key",
    });

    progressSidebar.mount({
        progressSidebarSelector: ".progress-sidebar",
        barThumbHeight: 24,
        barTopPos: 6,
    });

    cards.mount({
        guideCardSelector: ".guide-card",
        categoryCardSelector: ".category-card",
    });

    accordion.mount({
        accordionSelector: ".accordion",
    });

    cfButton.mount();

    packageButton.mount();

    trackClick.mount({ selector: ".track-click" });

    tables.mount({
        tableSelector: "table",
        standardTableModifier: ".table-standard",
        glossaryTableModifier: ".table-glossary",
    });

    $(".version-selector")
        .selectmenu({
            icons: {
                button: "fas fa-angle-down",
            },
            classes: {
                "ui-selectmenu-menu": "version-selector-menu",
            },
        }).on("selectmenuchange", (event, ui) => {
                event.preventDefault();

                const selectedVersion = ui.item.value;
                const selectedVersionNum = parseFloat(selectedVersion.substring(1), 10)

                if (selectedVersionNum > ARCHIVED_VERSION_END) {
                    window.location.href = `${NEW_DOCS_URL}/db/${selectedVersion}/en/introduction/singlestore-documentation.html`;
                } else {
                    window.location.href = window.versionJumps[selectedVersion];
                }
            }
        )

    $(".category-selector")
        .selectmenu({
            icons: {
                button: "fas fa-angle-down",
            },
            classes: {
                "ui-selectmenu-menu": "category-selector-menu",
            },
        })
        .on("selectmenuchange", function(event, ui) {
            event.preventDefault();
            const desiredCategoryUrl = ui.item.value;
            window.location.href = desiredCategoryUrl;
        });

    $(":header").each((idx, elt) => {
        const id = $(elt).attr("id");
        if (!id) return;

        const anchor = $("<a>", {
            href: "#" + id,
            class: "anchor-link",
        });

        const icon = $("<i>", {
            class: "fas fa-anchor",
        });

        $(elt).append(anchor.append(icon));
    });

    const $readTime = $(".read-time .minutes");

    if ($readTime.length) {
        const $content = $(".guide-step-container .content").text();
        const { minutes } = readingTime($content);

        $readTime.text(Math.round(minutes));
    }

    // position: sticky polyfill
    Stickyfill.add($("header"));

    initCodeBlockFeatures();

    function cloudTrialFromPortal() {
        const { referrer } = document;
        const portalDomains = [
            "portal.singlestore.com",
            "dev.helios.singlestore.com",
        ];

        portalDomains.forEach(domain => {
            if (referrer && includes(referrer, domain)) {
                $("a[href='https://www.singlestore.com/cloud']").attr(
                    "href",
                    "https://portal.singlestore.com/intention/cloud/"
                );
            }
        });
    }

    cloudTrialFromPortal();
});



// WEBPACK FOOTER //
// ./themes/docs/static/js/index.js